import { Text } from '@buffer-mono/popcorn'

import { AccessDenied } from '~publish/components/AccessDenied'
import type { AccessDeniedChannel } from '~publish/components/AccessDenied'
import { getChannelNameForDisplay } from '~publish/helpers/getChannelNameForDisplay'
import { isPublishSupported } from '~publish/utils/permissions/publishSupport'

import { PublishNotSupported } from './PublishNotSupported'

import type { JSX } from 'react'

/**
 * Missing Publish permissions and missing product support need different
 * explanations: an owner cannot grant access to an unsupported product.
 */
export const ChannelAccessDenied = ({
  channel,
}: {
  channel: AccessDeniedChannel & { products?: readonly string[] | null }
}): JSX.Element => {
  if (!isPublishSupported(channel)) {
    return <PublishNotSupported channel={channel} />
  }

  return (
    <AccessDenied
      channel={channel}
      description={
        <>
          You don&apos;t have publishing access to{' '}
          <Text weight="bold">{getChannelNameForDisplay(channel)}</Text>. Reach
          out to your organization owner to request access.
        </>
      }
    />
  )
}
